var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mobile-box" },
    [
      _c("van-nav-bar", {
        attrs: { title: "资料类型", "left-arrow": "" },
        on: { "click-left": _vm.back }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "info" },
        [
          _c(
            "van-cell-group",
            { attrs: { inset: "" } },
            [
              _vm.gldInfo.invoiceNoList.length > 0
                ? _c("van-cell", {
                    attrs: { title: "发票", "is-link": "" },
                    on: {
                      click: function($event) {
                        return _vm.toDataInfo("invoice")
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.gldInfo.contractNoList.length > 0
                ? _c("van-cell", {
                    attrs: { title: "合同", "is-link": "" },
                    on: {
                      click: function($event) {
                        return _vm.toDataInfo("contract")
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.gldInfo.invoiceNoList.length == 0 ||
          _vm.gldInfo.contractNoList.length == 0
            ? _c(
                "div",
                { staticStyle: { "font-size": "20px", "margin-left": "20px" } },
                [_vm._v("无贸易资料\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fac49a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fac49a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/mobile/DataType.vue
// module id = UJ43
// module chunks = 1